import { useQuery } from 'react-query';
import { getSubscriptionBlockUseCases } from '@subscriptions/composition';
import type { SubscriptionBlockViewDto } from '@subscriptions/application/dtos';

/**
 * Hook for listing all subscription blocks of the current organization.
 *
 * @param options - Optional query configuration
 * @returns Query result with subscription blocks
 */
export const useSubscriptionBlocks = (options?: { enabled?: boolean }) => {
  const { listSubscriptionBlocks } = getSubscriptionBlockUseCases();

  return useQuery<SubscriptionBlockViewDto[], Error>(
    ['subscriptions', 'blocks', 'list'],
    () => listSubscriptionBlocks.execute(),
    {
      enabled: options?.enabled ?? true,
      refetchOnWindowFocus: false,
      retry: 0,
    },
  );
};
